<template>
	<v-container grid-list-xl>
		<v-form v-model="isAddValid">
			<v-layout row wrap>						
				<v-flex lg12>
					<label class="blackLabel">* Reset Code:</label>			
					<v-text-field label="Reset Code" v-model="resetCode" required :rules="codeRules" single-line solo></v-text-field>
				</v-flex>
				<v-flex lg6>
					<label class="blackLabel">* New Password:</label>
					<v-text-field label="New Password" v-model="newPassword" required :rules="passwordRules" single-line solo></v-text-field>
				</v-flex>
              <v-flex lg6>
                <label class="blackLabel">* Confirm Password:</label>
                <v-text-field label="Confirm Password" v-model="confirmPassword" required :rules="confirmRules" single-line solo></v-text-field>
              </v-flex>
				<div class="pl-4 pr-1 pb-4 buttonHolder">
					<div style="float: right">
						<v-btn class="text-xs-right cancelButton" @click.stop="fncHideModal">Cancel</v-btn>
						<v-progress-circular indeterminate :width="3" :size="20" v-if="runAdd" color="grey" class="pt-3 loginLoader"></v-progress-circular>
						<v-btn color="success" class="text-xs-right" v-if="!runAdd" :disabled="!isAddValid" @click.stop="fncUpdatePassword()">Save</v-btn>
                      <small>* The button will activate once all required fields have been completed.</small>
					</div>
				</div>				
			</v-layout>
		</v-form>	
	</v-container>
</template>

<script>
	import { mapGetters } from 'vuex'; 	
	export default {
	  name: 'Settings',
	  data () {
			return {
				isAddValid: false,
				roleActive: false,
				resetCode: '',
				newPassword: '',
				confirmPassword: '',				
                codeRules: [
					v => !!v || 'Reset code is required'
				],
                passwordRules: [
					v => !!v || 'Password is required and has to match'				
				],
                confirmRules: [
                  v => !!v || 'Password is required and has to match'
			]			
			};
		},		
		methods: {
			fncHideModal () {
				this.$store.commit('hideModal');
			},
			fncUpdatePassword() {				
				this.$store.dispatch({
                  type: 'fncUpdatePassword',
                  resetCode: this.resetCode,
                  newPassword: this.newPassword,
                  confirmPassword: this.confirmPassword,
                  userId: this.globalModalParams.userId
				});
			}
		},
		computed: {
			...mapGetters([
				'objAuthorize',
				'globalModalParams',
				'runAdd'
			])
		},
        watch: {
            runAdd() {
                console.log( this.runAdd );
                if( this.runAdd === false ) {
                    this.isAddValid = false;
                    this.roleActive = '';
                    this.roleName = '';
                    this.roleDescription = '';
                    this.roleLevel = '';
                    this.roleUserType = '';
                }
            }
        }
	}
</script>

<style scoped>
	/*@import '../../assets/css/shared.css'*/
</style>